import { apiClient } from "api/client";

export async function getRepairCategoryApi() {
  const { data } = await apiClient.get("/get/repairCategory");
  return Array.isArray(data) ? data : [];
}

export async function getRepairDetailApi(tag) {
  const { data } = await apiClient.get("/get/repairDetail", { params: { tag } });
  return Array.isArray(data) ? data : [];
}

export async function getRepairDetail2Api(tag) {
  const { data } = await apiClient.get("/get/repairDetail2", {
    params: { tag },
  });
  return Array.isArray(data) ? data : [];
}
